let actions = {
    /**
     * @param commit
     * @returns {Promise<any>}
     */
    GET_PROJECTS({commit}, payload) {
        return axios.get(route('schedule.planning.project.all', payload))
            .then(response => {
                commit('getProjects', response.data.projects);
                commit('setCachedProjects', Object.freeze(response.data.projects));
                commit('canBeManaged', response.data.canBeManaged);
            })
            .catch();
    },
    /**
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    SET_PROJECTS({commit}, payload) {
        commit('getProjects', payload);
    },
    /**
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    SET_CACHED_PROJECTS({commit}, payload) {
        commit('setCachedProjects', payload);
    },
    /**
     * @param commit
     * @returns {Promise<any>}
     */
    GET_PERSONS({commit}) {
        return axios.get(route('schedule.planning.project.persons'))
            .then(response => {
                commit('getPersons', response.data.persons);
            })
            .catch();
    },
    /**
     * @param commit
     * @returns {Promise<any>}
     */
    GET_STATUSES({commit}) {
        return axios.get(route('schedule.planning.task.statuses'))
            .then(response => {
                commit('setStatuses', response.data.statuses);
            })
            .catch();
    },
    /**
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    GET_GROUPS({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.get(route('schedule.planning.project.groups', payload))
                .then(response => {
                    commit('getGroups', response.data.groups);

                    resolve(response.data);
                })
                .catch(error => {
                    console.error({error});
                });
        });
    },
    /**
     * @param commit
     * @param payload
     * @constructor
     */
    SET_GHOST_GROUP({commit}, payload) {
        commit('setGhostGroup', payload);
    },
    /**
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    SET_FULL_DAY_ABSENCES({commit}, payload) {
        commit('setFullDayAbsences', payload);
    },
    /**
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    SET_PART_DAY_ABSENCES({commit}, payload) {
        commit('setPartDayAbsences', payload);
    },
    /**
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    SET_WEEK_SCHEDULES({commit}, payload) {
        commit('setWeekSchedules', payload);
    },
    /**
     * @param commit
     */
    UPDATED({commit}) {
        commit('updated', (new Date()).getTime());
    },
    /**
     * @param commit
     * @param payload
     */
    ON_GROUP_DRAG_START({commit}, payload) {
        commit('draggingGroup', payload);
    },
    /**
     * @param commit
     */
    CLEANUP({commit}) {
        commit('getProjects', []);
        commit('canBeManaged', null);
        commit('getPersons', []);
        commit('setStatuses', []);
        commit('getGroups', []);
        commit('setFullDayAbsences', []);
        commit('setPartDayAbsences', []);
        commit('setWeekSchedules', []);
        commit('updated', null);
        commit('draggingGroup', {});
    }
};

export default actions;